import React, { Component } from 'react'
import { toJS } from 'mobx'
/*
 这个高阶函数要和mobx的store配合才行，一般用于改变搜索条件的时候
 参考SubjectComment/Tab/QaSubject/Subject
 type:修改的组件的类型，如date,input,select等
 fieldName:需要修改的字段名，和后台传过来的字段对应，不提供的话默认就等于type
 describe:一个描述对象包含：
 newValue:需要的修改的字段值，是一个数组，包含了所有传过来的参数
 serial:要获取的数组参数newValue的第几个参数,就是数组下标
 isForm:设置为true之后，会将所有的field存入一个字段中，这个字段默认是form，可通过下面的formName修改
 formName:修改字段名
 回调函数的参数
 store:对应的store
 afterChange:字段改变后希望执行的函数，或者是函数名
 widthOut:一个数组，表示那些类型字段change之后不需要执行afterChange回调,默认是['input']
 scope:afterChange函数执行的作用域，默认是store
 */
export default Cmp =>
  class extends Component {
    changeField = (type = 'input', fieldName, describe = {}) => (
      store,
      afterChange,
      withOut = ['input'],
      scope
    ) => {
      if (store) {
        if (fieldName && typeof fieldName !== 'string') {
          describe = fieldName
          fieldName = type
        }
        let { newValue = [], serial = 0, isForm = false, formName } = describe
        store.changeField = fieldValue => {
          fieldName = fieldName || type
          formName = formName || 'form'
          if (isForm && store[formName]) {
            let form = store[formName]
            //当fieldName为嵌套形式时(如'user.name')
            if (fieldName.indexOf('.') !== -1) {
              let arr = fieldName.split('.')
              arr
                .slice(0, arr.length - 1)
                .reduce((prev, next) => prev[next] || (prev[next] = {}), form)[
                arr[arr.length - 1]
              ] = fieldValue
            } else {
              form[fieldName] = fieldValue
            }
            store[formName] = toJS(form)
          } else {
            //分页的处理
            if (type === 'pagination' && store[fieldName]) {
              store[fieldName]['current'] = fieldValue.current
              store[fieldName]['pageSize'] = fieldValue.pageSize
            } else {
              store[fieldName] = fieldValue
            }
          }
          if (!withOut.includes(fieldName)) {
            if (typeof afterChange === 'function') {
              scope
                ? afterChange.bind(scope)({
                    type,
                    fieldName,
                    fieldValue
                  })
                : afterChange({ type, fieldName, fieldValue })
            } else if (typeof afterChange === 'string') {
              store[afterChange]()
            }
          }
        }
        //各种类型的处理
        switch (type) {
          case 'input':
          case 'radioGroup':
            let target = newValue[serial].target
            store.changeField(target ? target.value : newValue[serial])
            break
          case 'select':
            store.changeField(
              serial === 1 ? newValue[serial].props.children : newValue[serial]
            )
            break
          default:
            store.changeField(newValue[serial])
        }
      }
    }

    render() {
      return <Cmp {...this.props} changeField={this.changeField} />
    }
  }
